// eslint-disable-next-line import/prefer-default-export
export const decimalFormatter = (value, digits = 2) => {
  return value.toLocaleString(undefined, {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  });
};
